module.exports = __webpack_public_path__ + "static/assets/4e6e098c55b03fa9ac0179428ff8bf6d.png";